import { AutogenLayoutStandardCodeList } from "./autogen/AutogenLayoutStandardCodeList";
import { DataSourceAction, DataSourceExecutionEvent, Snackbar } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";

export class StandardCodeList extends AutogenLayoutStandardCodeList {

    sourceStandardCodeListBeforeExecution(event: DataSourceExecutionEvent) {
            if (DataSourceAction.SEARCH == event.getAction()) {
                if (
                    StringUtil.isEmptyString(this.textboxVersion.text)
                || (StringUtil.isEmptyString(this.textboxElementId.text) 
                && StringUtil.isEmptyString(this.textboxStandardCode.text) 
                && StringUtil.isEmptyString(this.textboxDescription.text) )

            ) {
                event.preventDefault();
                Snackbar.showWarningSnackbar("Version and at least one additional search criteria must be entered.")
                
            }
        }
    }

}
